import * as React from "react";
import Support from "src/pages/Support";
import Layout from "@components/Layout";
import Head from "next/head";

const Index = () => {
  return (
    <Layout>
      <Head>
        <title>Inawo | Support</title>
        <meta
          name="description"
          content="Contact Inawo support for account help, vendor support, and urgent event-day assistance. Reach our team by email or WhatsApp."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Support />
    </Layout>
  );
};

export default Index;
